import { DEFAULT_GRID_COLUMN_COUNT } from "./index.js";
const updateCSSVariables = (comp) => {
  var _a;
  const cache = {
    row: comp.dsf_gap,
    col: comp.dsf_gap
  };
  const rowVariable = "--dsf-grid-row-gap";
  const colVariable = "--dsf-grid-col-gap";
  if (comp.dsf_row_gap) {
    cache.row = comp.dsf_row_gap;
  }
  if (comp.dsf_col_gap) {
    cache.col = comp.dsf_col_gap;
  }
  if (cache.row) {
    comp.style.setProperty(rowVariable, `var(--dsf-spacing-${cache.row})`);
  } else {
    comp.style.removeProperty(rowVariable);
  }
  if (cache.col) {
    comp.style.setProperty(colVariable, `var(--dsf-spacing-${cache.col})`);
  } else {
    comp.style.removeProperty(colVariable);
  }
  comp.style.setProperty("--dsf-grid-cols", ((_a = comp.dsf_cols) == null ? void 0 : _a.toString()) || DEFAULT_GRID_COLUMN_COUNT);
};
export {
  updateCSSVariables
};
